import { useQuery } from '@apollo/client/react';

import {
  GetFeatureFlagsDocument,
  GetFeatureFlagsQuery,
} from '@/graphql/generated/graphql';

// スペルミスしないようにfeature定義
// リリースされてフラグ削除するときはここも忘れず削除すること
type FeatureFlag = 'Issue12436-display_qr_code';

const getFeatureFlags = (data?: GetFeatureFlagsQuery) => {
  if (!data) return [];

  return data.featureNames;
};

export const useFeatureFlag = (feature: FeatureFlag) => {
  const { data, loading } = useQuery(GetFeatureFlagsDocument, {
    fetchPolicy: 'cache-and-network',
  });
  const featureFlags = getFeatureFlags(data);

  return { isEnabled: featureFlags.includes(feature), loading };
};
